import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const VitalsView = ({ vitals }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const vitalDisplayOrder = [
    "Body Weight",
    "Body Temperature",
    "Heart Rate",
    "Respiratory Rate",
    "Capillary Refill Time",
    "Mucous Membrane Color",
    "Body Condition Score",
    "Pain Score",
    "Mentation",
    "Hydration Status",
    "Pulse Quality",
  ];

  const mappedRecords = useMemo(() => {
    const orderMap = vitalDisplayOrder?.reduce((acc, name, index) => {
      acc[name?.toLowerCase()] = index;
      return acc;
    }, {});

    const records = (vitals ?? reqDet?.vitals)?.flatMap((vit, i) => {
      return Object.entries(vit?.data?.[0] ?? {})
        ?.filter(
          ([_, value]) => value !== undefined && value !== null && value !== "",
        )
        ?.map(([key, value]) => ({
          vitalName: key,
          value: value,
          key: `${vit?.vitalId ?? i}-${key}`,
          originalIndex: i,
        }));
    });

    return (records ?? []).sort((a, b) => {
      const aOrder = orderMap[a?.vitalName?.toLowerCase?.()] ?? Number.MAX_SAFE_INTEGER;
      const bOrder = orderMap[b?.vitalName?.toLowerCase?.()] ?? Number.MAX_SAFE_INTEGER;

      if (aOrder !== bOrder) return aOrder - bOrder;
      return (a?.originalIndex ?? 0) - (b?.originalIndex ?? 0);
    });
  }, [vitals, reqDet?.vitals]);

  return (
    <div>
      <div className="flex-row-ali-cen ph10">
        <div className="w50Per">
          <Typography className="fs12 txt-semi-bold black">Name</Typography>
        </div>
        <div className="w50Per">
          <Typography className="fs12 txt-semi-bold black">Value</Typography>
        </div>
      </div>
      <div className="blk-hor-split mb3 mt10" />
      {mappedRecords?.map((vli) => (
        <div key={vli?.key}>
          <div className="flex-row ph10 mv5">
            <div className="w50Per pr5">
              <Typography className="fs12 font-medium black4">
                {vli?.vitalName}
              </Typography>
            </div>
            <div className="w50Per pr5">
              <Typography className="fs12 font-medium black4">
                {vli?.value}
              </Typography>
            </div>
          </div>
        </div>
      ))}
    </div>
    // <div className="ph10">
    //   {(vitals ?? reqDet?.vitals)?.map((vit) => {
    //     const vitalData = vit?.data?.[0] ?? {};
    //     return (
    //       <div className="gray-back-con" key={vit?.vitalId}>
    //         <div className="flex-row-ali-cen flex-row-wrap">
    //           <div className="gray-dot" />
    //           <Typography className="black fs12 font-bold ml5">
    //             {vit?.vitalGroup}
    //           </Typography>

    //           {Object.entries(vitalData)?.map(([key, value]) => {
    //             const reqValue =
    //               typeof value === "object" ? value?.value : value ?? "";
    //             return (
    //               <div className="flex-row-ali-cen ml5" key={key}>
    //                 <div className="gray-dot" />
    //                 <Typography className="black fs12 font-bold ml5">
    //                   {key}: {reqValue}
    //                 </Typography>
    //               </div>
    //             );
    //           })}
    //         </div>
    //       </div>
    //     );
    //   })}
    // </div>
  );
};

export default VitalsView;
